<template>
  <div class="bet-console-prefix" :style="cssVars">
    <v-app>
      <v-main>
        <router-view></router-view>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  data: () => ({
    cssVars: {},
  }),
  computed: {
    ...mapGetters({}),
    ...mapActions({}),
  },
  methods: {
    mountUserAgentMobileIfNeeded() {
      if (
        window.forceMobileView != null &&
        (window.forceMobileView === true || window.forceMobileView === 'true')
      ) {
        Object.defineProperty(navigator, 'userAgent', {
          get: function () {
            return 'Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 Mobile/15A372 Safari/604.1'
          },
        })
      }
    },
  },
  beforeCreate() {
    if (
      process.env.NODE_ENV == 'development' ||
      process.env.NODE_ENV == 'local'
    ) {
      const urlStyle = process.env.VUE_APP_URL_API + '/themes/get-style/' + skin

      fetch(urlStyle)
        .then(res => res.json())
        .then(out => {
          // console.log('Style:')
          // console.log(out.data.betconsole)
          this.cssVars = out.data.betconsole
        })
        .catch(err => {
          throw err
        })
    }
  },
  mounted() {
    this.mountUserAgentMobileIfNeeded()
  },
}
</script>

<style>
@import './assets/css/style.css';
@import './assets/css/responsive.css';
</style>
